module.exports = __webpack_public_path__ + "static/media/sq_jne.6ff4ed51.png";